export function buildPagination(totalItems: number, currentPage: number, itemsPerPage: number) {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const safePage = Math.min(Math.max(1, currentPage), totalPages);
  const start = Math.max(1, safePage - 2);
  const end = Math.min(totalPages, start + 4);
  const adjStart = Math.max(1, end - 4);
  const visiblePages = Array.from({ length: end - adjStart + 1 }, (_, i) => adjStart + i);
  return {
    currentPage: safePage,
    totalPages,
    totalItems,
    itemsPerPage,
    hasNextPage: safePage < totalPages,
    hasPreviousPage: safePage > 1,
    visiblePages,
  };
}

export function paginate<T>(items: T[], page: number, itemsPerPage: number) {
  const startIdx = (page - 1) * itemsPerPage;
  return items.slice(startIdx, startIdx + itemsPerPage);
}

export function filterDocuments(
  documents: any[],
  params: { search: string; status: string; category: string }
) {
  const { search, status, category } = params;
  const q = (search || '').toLowerCase();
  return documents.filter((document: any) => {
    const matchesSearch = !q ||
      document.title?.toLowerCase().includes(q) ||
      document.sender?.toLowerCase().includes(q) ||
      document.detectedDocumentCategory?.toLowerCase().includes(q);
    const matchesStatus = !status || document.status === status;
    const matchesCategory = !category || document.detectedDocumentCategory === category;
    return matchesSearch && matchesStatus && matchesCategory;
  });
}

export function filterUsers(
  users: any[],
  params: { search: string; status: 'all' | 'active' | 'invited' | 'blocked'; role: string }
) {
  const { search, status, role } = params;
  const q = (search || '').toLowerCase();
  return users.filter((u: any) => {
    const matchesSearch = !q || u.name?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q);
    const matchesStatus = status === 'all' || (u.status || 'active') === status;
    const matchesRole = !role || u.role === role;
    return matchesSearch && matchesStatus && matchesRole;
  });
}


